import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { ConfigurationService, CredentialsService } from './core';
import { AppInfoService } from './shared/services/app-info.services';
import Gleap from 'gleap';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

    constructor(private primengConfig: PrimeNGConfig,
        private credentialService: CredentialsService,
        private configurationService: ConfigurationService,
        public appInfo: AppInfoService,
        public translate: TranslateService,) { }

    ngOnInit(): void {
        this.primengConfig.ripple = true;
        const gleapApiKey = this.configurationService.config?.gleapApiKey;
        if (gleapApiKey) {
          Gleap.initialize(gleapApiKey);
        }
      }


  isAutorized() {
    return this.credentialService.isAuthenticated();
  }

}
